import { all } from 'redux-saga/effects';

import Setupscreensaga from './setup-screen-saga';

export default function* rootSaga(action) {
	yield all([Setupscreensaga(action)]);
}
